<template>
  <section class="login-page">
    <div class="login">
      <form
        class="login__content"
        v-on:submit.prevent="loginEmail"
      >
        <h1 class="login__branding">
          Colonial Life
        </h1>
        <p class="login__subtitle">Tech Platform Assistant</p>

        <div v-if="!isLoggingIn && !serverResponse">
          <p class="login__intro">
            Need help identifying an enrollment platform? Look up special features,
            view side-by-side comparisons, and get recommendations through a guided
            series of questions for your specific case. Enter your email to get started.
          </p>
          <p class="login__help">
            Check your inbox for an email from us. Once you've verified your email,
            you'll have access to this tool.
          </p>

          <unum-textbox
            name="loginEmail"
            label="Email Address"
            :hide-label="true"
            placeholder="Enter your Colonial Life email address"
            v-model="loginCred.email"
            v-validate="{
              required: true,
              // only cyberwoven.com or coloniallife.com domains
              regex: /^[a-zA-Z0-9\'_.+-]+@(?:(?:[a-zA-Z0-9-]+\.)?[a-zA-Z]+\.)?(coloniallife|coloniallifesales|unum|cyberwoven)\.com$/i
            }"
            data-vv-validate-on="blur"
            data-vv-value-path="loginEmail"
            :errorBag="errors"
          />

          <unum-button>Log In</unum-button>

          <!-- <div class="debug">
            <div
              @click="bypassEmailLogin"
              id="bypass-button"
            >
              Bypass Email Login
            </div>
          </div> -->
        </div>
      </form>
      <div class="spinner login__loading" v-if="isLoggingIn && !serverResponse">
        <div class="dot1"></div>
        <div class="dot2"></div>
      </div>
      <div v-if="isLoggingIn && serverResponse">
        Email sent to <strong>{{ loginCred.email }}</strong>. Check your inbox.
      </div>
    </div>
  </section>
</template>

<script>
import UnumButton from '@/components/ui/Button'
import UnumTextbox from '@/components/ui/Textbox'
// import firebase from 'firebase'
import { mapActions } from 'vuex'
import axios from 'axios'

import { sessionUrl, authServer } from '@/appConfig/appConfig.js'

export default {
  name: 'Login',
  components: {
    UnumButton,
    UnumTextbox
  },
  data () {
    return {
      loginCred: {
        email: '',
        sessionKey: null
      },
      isLoggingIn: false,
      serverResponse: false
    }
  },
  async created () {
    if (this.$route.query.jwt) {
      this.login(this.$route.query.jwt)
    }
  },
  methods: {
    ...mapActions('user', [
      'login'
    ]),
    loginEmail () {
      this.$validator.validateAll().then(async (result) => {
        // console.log(`Validation Result: ${result}`);
        this.loginErrorMsg = null
        const dis = this

        if (result) {
          this.isLoggingIn = true
          let sessionPathArray = [
            sessionUrl,
            'sessions',
            '.json'
          ]

          const sessionToFirebaseUrl = sessionPathArray.join('/')

          const firebaseResponse = await axios({
            method: 'post',
            url: sessionToFirebaseUrl,
            data: {
              email: this.loginCred.email,
              login_time: Date.now()
            }
          })

          this.loginCred.sessionKey = await firebaseResponse.data.name

          axios.post(authServer, await this.loginCred)
            .then(function (res) {
              dis.serverResponse = true
              window.location = '/email.html'
            })
            .catch(function (err) {
              console.log(err)
              // dis.$notify({
              //   type: 'error',
              //   group: 'site_notifications',
              //   title: 'Login Error: ' + err.response.status,
              //   text: err.response.statusText
              // })

              const firebaseResponse = axios({
                method: 'post',
                url: sessionToFirebaseUrl,
                data: {
                  errorStatus: err.response.status,
                  errorStatusText: err.response.statusText,
                  login_time: Date.now()
                }
              })
              console.log(firebaseResponse)
              dis.loginCred.email = null
              dis.isLoggingIn = false
            })
        }
      })
    },
    async bypassEmailLogin () {
      this.isLoggingIn = true
      const dis = this

      let sessionPathArray = [
        sessionUrl,
        'sessions',
        '.json'
      ]

      const sessionToFirebaseUrl = sessionPathArray.join('/')

      const firebaseResponse = await axios({
        method: 'post',
        url: sessionToFirebaseUrl,
        data: {
          email: this.loginCred.email,
          login_time: Date.now(),
          developer: true
        }
      })

      this.loginCred.sessionKey = await firebaseResponse.data.name

      axios.get(authServer, await this.loginCred)
        .then(res => {
          const token = res.data.token
          dis.login(token)
        })
        .catch(err => {
          console.log(err)
        })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
.login-page {
  height: 100vh;
  background-color: $steelblue3;
  @include bp($medium) {
    background-color: #5B7183;
  }
}
.login {
  left: 50%;
  margin: 0 auto;
  position: absolute;
  top: 50%;
  transform: translate(-50%, -50%);
  color: #fff;
  display: flex;
  flex-flow: column nowrap;
  align-items: center;
  justify-content: center;
  padding: 2rem;
  width: 100%;
  height: 100%;

  @include bp($medium) {
    background: $steelblue3;
    border-radius: 50%;
    box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.15);
    height: 50vw;
    width: 50vw;
    max-height: 512px;
    max-width: 512px;
    padding: 0 5rem;
  }

  @media screen and (orientation: portrait) and (min-width: $medium) {
    height: 50vh;
    width: 50vh;
  }

  &__content {
    text-align: center;
    max-width: 400px;
  }

  &__branding {
    display: block;
    background: url('~@/assets/images/brand/logo-login.svg') center bottom no-repeat;
    text-indent: -9999px;
    height: 12rem;
    margin: 0 auto rem(12px);
    max-width: 100%;
    background-size: contain;

    @include bp($medium) {
      height: 7.5rem;
    }
  }

  &__subtitle {
    margin: 0 0 1rem;
    color: $blueGrey;
    font-weight: bold;
    font-size: rem(17px);
  }

  &__intro {
    margin-bottom: 1rem;
    font-size: 1.25rem;
    text-align: left;
    @include bp($medium) {
      font-size: 0.8rem;
    }
  }

  &__help {
    margin-bottom: 1.5rem;
    font-size: 0.8rem;
    text-align: left;
    @include bp($medium) {
      margin-bottom: 1rem;
      font-size: 0.6rem;
    }
  }

  &__content {
    width: 100%;
  }
}

.spinner {
  margin: 6.250rem auto;
  width: 2.5rem;
  height: 2.5rem;
  position: relative;
  text-align: center;

  -webkit-animation: sk-rotate 2.0s infinite linear;
  animation: sk-rotate 2.0s infinite linear;
}

.dot1, .dot2 {
  width: 60%;
  height: 60%;
  display: inline-block;
  position: absolute;
  top: 0;
  background-color: #fff;
  border-radius: 100%;

  -webkit-animation: sk-bounce 2.0s infinite ease-in-out;
  animation: sk-bounce 2.0s infinite ease-in-out;
}

.dot2 {
  top: auto;
  bottom: 0;
  -webkit-animation-delay: -1.0s;
  animation-delay: -1.0s;
}

@-webkit-keyframes sk-rotate { 100% { -webkit-transform: rotate(360deg) }}
@keyframes sk-rotate { 100% { transform: rotate(360deg); -webkit-transform: rotate(360deg) }}

@-webkit-keyframes sk-bounce {
  0%, 100% { -webkit-transform: scale(0.0) }
  50% { -webkit-transform: scale(1.0) }
}

@keyframes sk-bounce {
  0%, 100% {
    transform: scale(0.0);
    -webkit-transform: scale(0.0);
  } 50% {
    transform: scale(1.0);
    -webkit-transform: scale(1.0);
  }
}

.debug {
  position: absolute;
  top: 100%;
  left: 0;
  width: 100%;
  margin: 20px 0 0;
  text-align: center;
  div {
    cursor: pointer;
    display: inline-block;
    text-decoration: underline;
    &:hover {
      text-decoration: none;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Login.vue